import React from 'react';


export default class button extends React.Component {

    render() {
        return <a href={this.props.href} target={this.props.target}  className={"button " + this.props.extra}>{this.props.children}</a>
    }

}



// WEBPACK FOOTER //
// ./src/scripts/components/button.jsx